import React from "react";
import { PiUserFill } from "react-icons/pi";
import styles from "./index.module.css";
import mainImage from "../../../layout/assets/touch_pos_front_view.png";
import sideCardImage from "../../../layout/assets/pc.png";

const TopContainer = ({ products = [] }) => {
  const withImages = products.filter((product) => product.image_url);
  const cardImage = withImages[1]?.image_url || sideCardImage;

  return (
    <section className={styles.hero}>
      <div className={styles.heroInner}>
        <div className={styles.heroLeft}>
          <h1 className={styles.heroTitle}>
            Reliable POS Hardware
            <br />
            Accessories
          </h1>
          <p className={styles.heroDescription}>
          The hardware behind every smooth transaction. Scanners, printers,
            and displays built to keep your counter fast, professional, and
            always ready.
          </p>
          <div className={styles.heroActions}>
            <a className={styles.heroPrimaryBtn} href="#catalog">
              Explore Products
            </a>
            <a className={styles.heroSecondaryBtn} href="/#info">
              About
            </a>
          </div>
        </div>

        <div className={styles.heroCenter}>
          <img
            className={styles.heroImage}
            src={mainImage}
            alt="Epinics POS hardware"
          />
        </div>

        <div className={styles.heroRight}>
          <div className={styles.sideCard}>
            <img
              className={styles.sideCardImage}
              src={cardImage}
              alt={withImages[1]?.title || "POS accessory"}
            />
          </div>

          <div className={styles.socialProof}>
            <div className={styles.socialProofTop}>
              <div className={styles.avatarStack}>
                {[0, 1, 2].map((i) => (
                  <div key={i} className={styles.avatar} aria-hidden="true">
                    <PiUserFill className={styles.avatarIcon} />
                  </div>
                ))}
              </div>
              <div className={styles.statValue}>100+</div>
            </div>
            <p className={styles.statText}>
              Satisfied customers islandwide. We take pride in delivering
              top quality products.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopContainer;
